import React from 'react';
import './Contact.css';

const Contact = () => {
  const contacts = [
    { icon: '📧', title: 'General Inquiries', info: 'info@envirotekgroup.org' },
    { icon: '🤝', title: 'Partnerships', info: 'info@envirotekgroup.org' },
    { icon: '📰', title: 'Media', info: 'info@envirotekgroup.org' },
    { icon: '📍', title: 'Office', info: 'Kingston, Jamaica' }
  ];

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>Get in Touch</h2>
        <div className="contact-grid">
          {contacts.map((contact, index) => (
            <div key={index} className="contact-card">
              <h3>{contact.icon} {contact.title}</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{contact.info}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
